export const SCROLL_SPEED = 800;
export const EASE_CUSTOM = "cubic-bezier(0.645, 0.045, 0.355, 1)";
